/*
 * Author: Harper Yan
 * File Created: Tuesday, 25-04-08 06:49 pm
 * Last Modified: Tuesday, 25-04-08 06:49 pm, by Harper Yan
 */

export const generatePaths = (
  paths: string[],
  supportLanguage: string[] = ['zh', 'en'],
) => {
  return paths.flatMap((path) => [
    path,
    ...supportLanguage.map((lang) => `/${lang}${path}`),
  ]);
};
